<template>
  <div>
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6">{{ title }}</h3>
          <p class="mt-1 text-sm text-white text-opacity-75">
            {{ subtitle }}
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form action="#" method="POST" @submit.prevent>
          <div
            class="shadow sm:rounded-md sm:overflow-hidden bg-gray-800 border border-gray-500"
          >
            <div class="px-4 py-5 space-y-6 sm:p-6">
              <slot />
            </div>
            <!-- Actions -->
            <div class="px-4 py-3 text-right sm:px-6 border-t border-gray-500">
              <slot name="actions" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    title: String,
    subtitle: String
  }
});
</script>

<style></style>
